module.exports = __webpack_public_path__ + "static/media/img_homepage_menu_06-External_default.aff36e00.png";